import { isAxiosError } from 'axios';

interface ApiErrorBody {
    message?: string;
    errors?: Record<string, string[]>;
}

/** Laravel-style 422 field errors (`Record<field, string[]>`), or null when not a 422. */
export const getValidationErrors = (error: unknown): Record<string, string[]> | null => {
    if (isAxiosError<ApiErrorBody>(error) && error.response?.status === 422) {
        return error.response.data?.errors ?? {};
    }
    return null;
};

/** Best human-readable message from an API error (server message first). */
export const getApiErrorMessage = (error: unknown, fallback: string): string => {
    if (isAxiosError<ApiErrorBody>(error)) {
        return error.response?.data?.message || error.message || fallback;
    }
    if (error instanceof Error && error.message) return error.message;
    return fallback;
};
